module.exports = __webpack_public_path__ + "img/h-page4-51.db2a3040.png";